import { render, staticRenderFns } from "./PopupBase.vue?vue&type=template&id=507d6306&scoped=true&"
import script from "./PopupBase.vue?vue&type=script&lang=js&"
export * from "./PopupBase.vue?vue&type=script&lang=js&"
import style0 from "./PopupBase.vue?vue&type=style&index=0&id=507d6306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d6306",
  null
  
)

export default component.exports